(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name administracio.penalitzacions.criticitat.controller:AdministracioPenalitzacionsCriticitatSubmainCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.shared.headerSubmenu')
    .controller('HeaderSubmenuCtrl', HeaderSubmenuCtrl);

  function HeaderSubmenuCtrl(
                optionsHeaderSubmenuData,
                AppHeaderSubmenuFactory,
                PermisosFactory,
                $rootScope, $scope, $state, $stateParams, $log) {
    var vm = this;

    if (!angular.isUndefined(optionsHeaderSubmenuData.addPermit) && optionsHeaderSubmenuData.addPermit !== null
      && (angular.isUndefined($stateParams.submenuInfo.left.addButton) || $stateParams.submenuInfo.left.addButton)) {
      $stateParams.submenuInfo.left.addButton = PermisosFactory.isVisible(optionsHeaderSubmenuData.addPermit, 'add');
    }

    $scope.$on(optionsHeaderSubmenuData.name + '.showOptionSubmenu',function(event, data){
      if (data.show){
        angular.forEach(optionsHeaderSubmenuData.options, function(key){
          if (key.permit) {
            key.show = PermisosFactory.isVisible(key.permit, 'read');
          } else {
            key.show = true;
          }
        });
      }else{
        angular.forEach(optionsHeaderSubmenuData.options, function(key){
          key.show = false;
        });
      }
    });

    AppHeaderSubmenuFactory.resize($state, $stateParams, optionsHeaderSubmenuData.name);

    AppHeaderSubmenuFactory.createAttributes(vm, optionsHeaderSubmenuData.options, $stateParams, false);


  }
}());
